const theme = {
    primaryColor: '#5B3CC4',
    secondaryColor: '#EDEEF2',
    textDark: '#545453',
    textLight: '#98999D',
    white: '#FFFFFF',
    successColor: '#3DAC4B',
    errorColor: '#EE1B24'
};

export default theme;